// Deterministic slug for heading anchor ids and similar use cases.
// Lowercases, strips non-ASCII-alphanumeric, collapses runs of separators
// into a single hyphen, trims edge hyphens.
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}